import { Text } from '@chakra-ui/react';
import RoutableModal from 'components/general/RoutableModal';
import { useClientUpdateMutation } from 'generated/graphql';
import { FormProvider } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import ClientForm from '../ClientForm';
import { useEditClientForm } from './lib';

function EditClient() {
  const { clientId: id } = useParams() as { clientId: string };
  const [client, form] = useEditClientForm();
  const navigate = useNavigate();
  const goBack = () => navigate(-1);
  const [updateClient, { loading }] = useClientUpdateMutation({
    onCompleted: goBack,
  });

  const handleSubmit = form.handleSubmit(data => updateClient({ variables: { id, data } }));

  if (client.loading) return null;

  return (
    <RoutableModal
      title="Edit Client"
      buttons={{ action: { text: 'Save', handler: handleSubmit } }}
      loading={loading}
    >
      <Text mb={10}>Please enter the required information to update this client</Text>
      <FormProvider {...form}>
        <ClientForm isEdit />
      </FormProvider>
    </RoutableModal>
  );
}

export default EditClient;
